module.exports = __webpack_public_path__ + "img/copy.2def2a03.svg";